//SHIFT+ALT+F
import axios from 'axios';   //数据请求组件
import { Loading } from 'element-ui';
import { message } from './msg'
import debounce from '@/utils/debounce';
import baseData from './baseData';
import router from '../router'


const http = axios.create({ baseURL: sys.apiUrl, timeout: 30000 })  // 创建axios的对象(默认10s超时，可在请求时候设置：{timeout: 2000})
let loading;  //loading对象
let needLoadingRequestCount = 0;  //当前正在请求的数量

//显示loading
function showLoading(target) {
    // 后面这个判断很重要，因为关闭时加了抖动，此时loading对象可能还存在，
    // 但needLoadingRequestCount已经变成0.避免这种情况下会重新创建个loading
    if (needLoadingRequestCount === 0 && !loading) {
        loading = Loading.service({
            lock: true,
            text: "数据加载中...",
            background: 'rgba(0, 0, 0, 0.5)',
            target: target || "body"
        });
    }
    needLoadingRequestCount++;
}

//隐藏loading
function hideLoading() {
    needLoadingRequestCount--;
    needLoadingRequestCount = Math.max(needLoadingRequestCount, 0); //做个保护
    if (needLoadingRequestCount === 0)
        toHideLoading();//关闭loading
}

//防抖：将 300ms 间隔内的关闭 loading 便合并为一次。防止连续请求时， loading闪烁的问题。
// var toHideLoading = debounce(() => {
//     if (loading && loading != null && needLoadingRequestCount==0) {
//         loading.close();
//         loading = null;
//     }
// }, 200);
var toHideLoading = () => {
    if (loading && loading != null && needLoadingRequestCount==0) {
        loading.close();
        loading = null;
    }
}

//添加请求拦截器
http.interceptors.request.use(
    _config => {
        let user = baseData.vue_user;
        if (user && user.Token)
            _config.headers.Token = user.Token;
        console.log(_config.data);  //打印请求数据
        if (_config.showLoading==undefined || _config.showLoading!==false)
            showLoading(_config.headers.loadingTarget);
        return _config;
    },
    err => {
        if (!_config.showLoading)
            hideLoading();
        message.error('请求超时!');
        return Promise.resolve(err);
    }
);

//响应拦截器
http.interceptors.response.use(
    function (response) {
        if (response.config.showLoading==undefined || response.config.showLoading!==false)
            hideLoading();
        console.log(response.config.data, response);
        //判断返回error = 异常
        if ( response.data && !response.data.success && response.headers['content-type'].indexOf('/json')!=-1 ) {// 过滤掉blob类型
            if (response.data.message && response.data.message.indexOf("Token") != -1) { //这里没有异常分类编码，暂时用字符串比对
                baseData.vue_user = null;
                //router.push('/login');
            } else
                message.error({ message: `请求返回异常信息：${response.data.message}`, duration: "1500" });
        }
        //特殊处理：所有返回表加上checked属性，用于vxttable的checkbox提高渲染性能。
        if (response.data && response.data.data && Array.isArray(response.data.data)) {
            if (response.data.data.length > 0 && response.data.data[0]["_row_checked"]==undefined){  //如果数据库没有返回该字段
                let _row_checked = typeof(response.config.defaultChecked) == 'boolean'? response.config.defaultChecked : false;
                response.data.data.forEach(element => element._row_checked = _row_checked);
            }
            //response.data.data = response.data.data.map(item=>{item._row_checked=false; return item;})
        }
        
        return response;
    },
    function (error) {
        if (!error.config.showLoading)
            hideLoading();
        console.log(error);
        message.error("网络异常：" + error); //error.config.url
        return Promise.reject(error);
    }
);
export default http;


// WEBPACK FOOTER //
// ./src/utils/http.js